import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';
import { containerPaddingM } from 'common/styles/variables';

/**
 * A container with a bit of spacing and that arranges its children vertically.
 * Used for the vertical edit view.
 */
const EditViewSectionContainer = styled(SuiContainer).attrs({
    variation: 'flex-vertical flex-inherit',
})`
    padding: ${containerPaddingM};
`;

export default EditViewSectionContainer;
